export default __webpack_public_path__ + "static/media/Sylvia_Makario_AHV_In_Moms_We_Trust.7331cbea.jpg";